import React from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, Box, Button, Stack } from '@mui/material';
import ReusableButton from "../../components/reusableComponents/reusableButtonComponents";
import ReusableMuiIcons from '../../_helpers/ReusableMuiIcons';
import ReusableHeadingComponents from './reusableHeadingComponents';

export default function ConfirmMessageBox({ open, onClose, onSubmit ,title , message , children , heading , subHeading}) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth sx={{
            '& .MuiDialog-paper': {
                // width: '550px',
                borderRadius: '12px',
            }}}>
            <DialogTitle>
                <Box display="flex" justifyContent="center" mb={1} pt={2}>
                    <Box
                        sx={{
                            backgroundColor: '#FEF9C3',
                            borderRadius: '50%',
                            padding: 1.5,
                        }}
                    >
                        <ReusableMuiIcons name={'info'} sx={{ color: "#FDB428", fontSize: '35px' }} />
                    </Box>
                </Box>
            </DialogTitle>
            <DialogContent>
                <ReusableHeadingComponents heading={heading} subHeading={subHeading} />
                {title && (<Box display="flex" alignItems="center" bgcolor="#FEF2F2" borderRadius={'12px'} p={1.5} mb={1} sx={{ border: "1px solid #FECACA", gap: 1 }}>
                    <ReusableMuiIcons name={"lock"} sx={{ color: '#F14950' }} />
                    <Typography color="#7A7A7A" sx={{fontSize:'14px'}}>{title}</Typography>
                </Box>)}

                {message && (<Box display="flex" alignItems="center" bgcolor="#F0FDF4" borderRadius={'12px'} p={1.5} gap={1} sx={{border: "1px solid #DAFBE5"}}>
                    <ReusableMuiIcons name={'tick'} sx={{ color: '#16A34A' }} />
                    <Typography color="#7A7A7A" sx={{fontSize:'14px'}}>{message}</Typography>
                </Box>)}

                <Stack direction="row" justifyContent="flex-end" mt={3}>
                    <ReusableButton children={'Cancel'}  variant="outlined" classNames={'gn-actionbtn-outline gn-actionbtn-color me-3'} onClick={onClose} />
                    <ReusableButton variant="contained" classNames={'gn-actionbtn'} children={children} sx={{ marginRight: '10px' }} onClick={onSubmit} />
                </Stack>
            </DialogContent>
        </Dialog>
    );
}
